export const isString = (value: unknown) => typeof value === 'string'
export const isBoolean = (value: unknown) => typeof value === 'boolean'
export const isStringOrUndefined = (value: unknown) => typeof value === 'string' || value === undefined
export const isStringOrNull = (value: unknown) => typeof value === 'string' || value === null
